var _style, _polygon, _g, _g2, _g3, _polygon2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mhd-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 252.7 180.7",
    style: {
      enableBackground: "new 0 0 252.7 180.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ffffff;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "stripe-5",
    className: "st0",
    points: "215,119.5 215,141.9 192.7,141.9 167.8,166.7 206.3,166.7 238.2,134.8 238.2,96.3 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stripe-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "s4c",
    className: "st0",
    points: "171.7,99.4 171.7,132.4 188.2,116 188.2,99.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "s4b",
    className: "st0",
    points: "238.2,27.5 215,50.7 215,89.1 238.2,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "s4a",
    className: "st0",
    points: "144.9,120.8 138.8,126.9 138.8,141.9 123.8,141.9 98.9,166.7 137.4,166.7 162.3,141.9  144.9,141.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stripe-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s3b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "144.9,52 138.8,58.1 138.8,96.5 144.9,90.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.7,38.8 171.7,63.6 188.2,47.1 188.2,38.8 196.5,38.8 221.4,13.9 182.9,13.9 158,38.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "s3a",
    className: "st0",
    points: "79.8,141.9 75.9,121 65.2,131.7 65.2,141.9 55,141.9 30.1,166.7 68.6,166.7 93.5,141.9  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "stripe-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "s2c",
    className: "st0",
    points: "85.9,80.6 94.5,72 100.4,38.8 127.7,38.8 152.6,13.9 114.1,13.9 80.1,47.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "s2b",
    className: "st0",
    points: "40.1,87.9 15,113 15,151.4 40.1,126.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "s2a",
    className: "st0",
    points: "71.1,95.4 65.5,65.1 65.2,65.1 65.2,101.3  "
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "stripe-1",
    className: "st0",
    points: "40.1,38.8 58.8,38.8 83.7,13.9 45.2,13.9 15,44.1 15,82.6 40.1,57.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "initials-bg",
    className: "st0",
    d: "M35.1,33.7v113.1h184.8V33.7H35.1z M138.8,141.9h-25.1V65.1h-0.3l-14.3,76.8H79.8L65.5,65.1 h-0.3v76.8H40.1V38.8h38.4l10.8,61.1h0.3l10.8-61.1h38.4L138.8,141.9L138.8,141.9z M215,141.9h-26.8V99.4h-16.5v42.4h-26.8v-103 h26.8v37.8h16.5V38.8H215V141.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a415ede734fe5b48f5a21e0890a0ab36.svg";
export { ForwardRef as ReactComponent };